
export default {
  name: 'HeaderCardContent',
  props: {
    headerCards: { required: true, type: Array },
  },
}
